import * as React from 'react';
import { Answer } from '../../types';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import style from './style.module.scss';

export default function AnswerDifficulty({ humanDifficulty }: Answer) {
  return (
    <span role="figure" aria-label={humanDifficulty}>
      {humanDifficulty === 'Easy' && renderDots(1, 4)}
      {humanDifficulty === 'Medium' && renderDots(2, 4)}
      {humanDifficulty === 'Hard' && renderDots(3, 4)}
      {humanDifficulty === 'Very Hard' && renderDots(4, 4)}
      {humanDifficulty === 'Unknown' && null}
    </span>
  );
}

function renderDots(num, total) {
  return new Array(total)
    .fill(null)
    .map((dot, idx) => (
      <FontAwesomeIcon
        icon={idx < num ? 'circle' : 'circle-thin'}
        className={style.difficultyIcon}
        key={idx}
      />
    ));
}
